
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import IntelligentQA, {
  AIQaCreateOrUpdate,
  AIQaPair
} from "@/lib/model/intelligentQA";
import AskGoOn from "@/components/ask-go-on.vue";

@Component({
  components: {
    AskGoOn
  }
})
export default class ApplicationRule extends Vue {
  @Prop({}) qaItem?: AIQaPair;
  @Prop({}) visible!: boolean;

  title = "";
  isAdd = false;

  confirmShow = false;
  confirmConfig = {
    default: {
      title: "确认修改问题吗？",
      content: "修改后所有使用该问题的面试答疑官都会同步修改，请确认"
    }
  };
  onConfirmOk(): void {
    this.createOrUpdate();
  }

  form: AIQaCreateOrUpdate = {
    shortName: "",
    standardQuestion: "",
    standardAnswer: "",
    userId: Auth.userId
  };

  rules = {
    shortName: [
      { required: true, message: "请输入问题简称", trigger: "blur" },
      { max: 10, message: "最多输入10个字", trigger: "blur" }
    ],
    standardQuestion: [
      { required: true, message: "标准问法禁止为空", trigger: "blur" },
      { max: 128, message: "最多输入128个字", trigger: "blur" }
    ],
    standardAnswer: [
      { required: true, message: "标准回答禁止为空", trigger: "blur" },
      { max: 255, message: "最多输入255个字", trigger: "blur" }
    ]
  };

  loading = false;

  @Watch("visible", { immediate: true })
  async getInfo(isShow: boolean): Promise<void> {
    console.log("🚀 ~ ApplicationRule ~ getInfo ~ isShow:", isShow);
    if (isShow) {
      if (this.qaItem?.id) {
        // 编辑
        this.isAdd = false;
        this.title = "编辑问题";
        this.form.qaId = this.qaItem.id;
        this.form.shortName = this.qaItem.shortName;
        this.form.standardQuestion = this.qaItem.standardQuestion;
        this.form.standardAnswer = this.qaItem.standardAnswer;
      } else {
        // 新增
        this.isAdd = true;
        this.title = "添加问题";
        this.form.shortName = "";
        this.form.standardQuestion = "";
        this.form.standardAnswer = "";
      }
    }
  }

  ok(): void {
    if (this.isAdd) {
      this.createOrUpdate();
    } else {
      this.confirmShow = true;
    }
  }

  async createOrUpdate(): Promise<void> {
    if (this.loading) return;
    this.loading = true;
    try {
      await this.checkData();
      if (this.form.qaId) {
        await IntelligentQA.update(this.form);
      } else {
        await IntelligentQA.create(this.form);
      }
      this.$emit("ok");
      this.close();
    } catch (e) {
      console.log("🚀 ~ ApplicationRule ~ ok ~ e:", e);
    } finally {
      this.loading = false;
    }
  }

  async checkData(): Promise<{ code: number; message: string }> {
    return new Promise((resolve, reject) => {
      (this.$refs.form as any).validate((valid: boolean) => {
        if (valid) {
          resolve({ code: 200, message: "成功" });
        } else {
          reject({ code: 201, message: " 失败" });
        }
      });
      return resolve({ code: 200, message: "成功" });
    });
  }

  close(): void {
    this.$emit("update:visible", false);
  }
}
